import * as d3 from 'd3';

export function drawShortFractionalGrills(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2,
  includeTop = true,
  includeBottom = false,
  grillThickness = 2
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const grillHeight = glassHeight * 0.25; // 25% of height

  const leftX = glassX + glassWidth * 0.2;
  const rightX = glassX + glassWidth * 0.8;
  const topY = glassY;
  const bottomY = glassY + glassHeight - grillHeight;

  if (includeTop) {
    // Left top grill
    svg.append('rect')
      .attr('x', leftX - grillThickness / 2)
      .attr('y', topY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);

    // Right top grill
    svg.append('rect')
      .attr('x', rightX - grillThickness / 2)
      .attr('y', topY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  if (includeBottom) {
    // Left bottom grill
    svg.append('rect')
      .attr('x', leftX - grillThickness / 2)
      .attr('y', bottomY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);

    // Right bottom grill
    svg.append('rect')
      .attr('x', rightX - grillThickness / 2)
      .attr('y', bottomY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }
}

export function drawShortFractionalGrills2(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  lineColor = 'white',
  includeTop = true,
  includeBottom = false,
  grillThickness = 2
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const grillHeight = glassHeight * 0.25; // 25% of height

  const leftX = glassX + glassWidth * 0.2;
  const rightX = glassX + glassWidth * 0.8;
  const topY = glassY;
  const bottomY = glassY + glassHeight - grillHeight;

  if (includeTop) {
    // Left top grill
    svg.append('rect')
      .attr('x', leftX - grillThickness / 2)
      .attr('y', topY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor);

    // Right top grill
    svg.append('rect')
      .attr('x', rightX - grillThickness / 2)
      .attr('y', topY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor);
  }

  if (includeBottom) {
    // Left bottom grill
    svg.append('rect')
      .attr('x', leftX - grillThickness / 2)
      .attr('y', bottomY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor);

    // Right bottom grill
    svg.append('rect')
      .attr('x', rightX - grillThickness / 2)
      .attr('y', bottomY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor);
  }
}

export function drawShortFractionalGrills1(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  grillHeightRatio = 0.25,
  lineColor = 'white'
) {
  const grillThickness = 2;

  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const partialHeight = glassHeight * grillHeightRatio;

  // Positions for left and right vertical grills
  const offsetX = 0.15 * glassWidth;

  [offsetX, glassWidth - offsetX].forEach((gx) => {
    svg.append('rect')
      .attr('x', glassX + gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', partialHeight)
      .attr('fill', lineColor);
  });
}
